import React from 'react';
import * as scriptUtils from './utils/scriptUtils';

function Profile(props) {
  return (
    <div className="flex flex-col items-center justify-center h-56 w-full">
      {
        props.account != null
          ?
        <img className="h-20 w-20" src={scriptUtils.getProfileImage(props.account.address)} alt="PPV NFT" />
          :
        null
      }
      <div className="text-4xl mt-4 text-black dark:text-white font-bold">
        {
          props.account != null
            ?
          props.account.address.substring(0, 5) + "..." + props.account.address.substring(props.account.address.length - 5)
            :
          "No wallet connected"
        }
      </div>
    </div>
  );
}

export default Profile;
